import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { mergeDevConfigFormStorage } from '@weike/toolkit';

export const isDev =
  'dbg.weike.fm' === location.hostname ||
  'dbg.lizhiweike.com' === location.hostname ||
  'localhost' === location.hostname;

const devConfig = () => {
  const defaultConfig = {
    WX_APP_ID: 'wx3502aeb0c3639966',
    BASE_URL: `https://dbg.lizhiweike.com`,
    MAIN_URL: `https://dbg.lizhiweike.com`,
    ADMIN_URL: `https://dev.admin.lizhiweike.com`,
    WFW_BASE_URL: `https://gateway.dev2.weike.fm`,
    NEW_GATEWAY_URL: `https://api.dev10.weike.fm`
  };

  return mergeDevConfigFormStorage(defaultConfig) as {
    [key in keyof typeof defaultConfig]: string;
  };
};
const PRESET_MAIN_URL = Session && Session.preset_config && Session.preset_config.mainUrl;

const PRESET_BASE_URL = Session && Session.preset_config && Session.preset_config.baseUrl;

const prodConfig = {
  ADMIN_URL: 'https://admin.lizhiweike.com',
  BASE_URL: PRESET_BASE_URL || 'https://apiv1.lizhiweike.com',
  MAIN_URL: PRESET_MAIN_URL || 'https://m.lizhiweike.com',
  ADMIN_BASE_URL: 'https://admin.lizhiweike.com',
  WX_APP_ID: 'wx3502aeb0c3639966',
  WFW_BASE_URL: 'https://gateway-weike.lizhiweike.com',
  NEW_GATEWAY_URL: 'https://api-gw.lizhiweike.com'
};
export const Config = isDev ? devConfig() : prodConfig;

declare const Session: any;

export interface IResponse<T> {
  code: number;
  data: T;
  msg: string;
}
export interface ISuccessRequestConfig extends AxiosRequestConfig {
  successCode?: string;
}
class Request {
  private static getData<T extends IResponse<any>>(
    response: AxiosResponse<T>,
    extSuccessCode?: string | number
  ): T['data'] {
    const { data } = response;
    if (data.code === 0 || ('code' in data && data.code === extSuccessCode)) {
      return data.data;
    } else {
      throw data;
    }
  }

  public async $getAdmin<T>(url: string, options?: AxiosRequestConfig): Promise<T> {
    const axios = await this.getAxios();
    return Request.getData<IResponse<T>>(
      await axios.get<IResponse<T>>(Config.ADMIN_URL + url, options)
    );
  }

  public async $get<T>(
    url: string,
    options?: AxiosRequestConfig,
    extSuccessCode?: string | number
  ): Promise<T> {
    const axios = await this.getAxios();
    return Request.getData<IResponse<T>>(
      await axios.get<IResponse<T>>(url, {
        baseURL: Config.BASE_URL,
        ...options
      }),
      extSuccessCode
    );
  }

  public async $post<T>(url: string, data?: any, options?: ISuccessRequestConfig): Promise<T> {
    const axios = await this.postAxios();
    return Request.getData<IResponse<T>>(
      await axios.post<IResponse<T>>(Config.BASE_URL + url, data, options),
      options && options.successCode
    );
  }
  public async $postJson<T>(url: string, data?: any, options?: AxiosRequestConfig): Promise<T> {
    const axios = await this.postAxios();
    return Request.getData<IResponse<T>>(
      await axios.post<IResponse<T>>(url, data, {
        baseURL: Config.BASE_URL,
        ...(options || {})
      }),
      '0000'
    );
  }

  private getAxios(): Promise<AxiosInstance> {
    return new Promise((resolve, reject) =>
      Session.getToken(
        ({ token }: { token: string }) => resolve(Axios.create({ params: { token } })),
        reject
      )
    );
  }

  private postAxios(): Promise<AxiosInstance> {
    return new Promise((resolve, reject) =>
      Session.getToken(
        ({ token }: { token: string }) =>
          resolve(
            Axios.create({
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
              params: { token }
            })
          ),
        reject
      )
    );
  }
}

export default new Request();



// WEBPACK FOOTER //
// ./src/services/lib/request.ts